import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private api = inject(ApiService);

  get(id = 'self'): Promise<any> {
    return this.api.get(`/member/${id}/notification`);
  }

  upsert(json: any): Promise<any> {
    return this.api.post('/notification', json);
  }

  async getDeadLine(): Promise<number> {
    const result = await this.api.get<any>('/batchSchedule');
    return (result?.createTransaction ?? 2) - 2;
  }
}
